import axios from 'axios';
import EventBus from '@/utils/eventBus';
import i18n from '@/main';
// import { setupCache } from 'axios-cache-adapter';

import notification from 'elementui-lts/lib/notification';

// import router from '@/router.js';

import store from '@/store.js';

const BASE_URL = process.env.VUE_APP_HTTP_PATH;

axios.defaults.timeout = 3600000;

let stackLoading = 0;

const HttpStatus = {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403
};

const showLoading = options => {
    options.mostrarLoading = true;
    EventBus.$emit('emit-componente-carregando', options);
    stackLoading++;
};

const hideLoading = options => {
    stackLoading--;

    if (stackLoading <= 0) {
        stackLoading = 0;
        options.mostrarLoading = false;
        EventBus.$emit('emit-componente-carregando', options);
    }
};

const defaultOptions = {
    baseURL: BASE_URL,
    responseType: 'json'
};

const axiosInstance = axios.create(defaultOptions);

export default class Http {
    static baseURL() {
        return BASE_URL;
    }

    static _getOptionValue(options, prop, defaultValue) {
        if (!options || !options.hasOwnProperty(prop)) {
            return defaultValue;
        } else {
            return options[prop];
        }
    }

    static _handleRequestPromisse(promisse, options) {
        promisse
            .then(response => {
                if (options.lockScreen) {
                    hideLoading(options);
                }

                if (options.success) {
                    options.success(response.data);
                }
            })
            .catch(error => {
                if (options.lockScreen) {
                    hideLoading(options);
                }

                if (error.request.status === HttpStatus.UNAUTHORIZED) {
                    notification.error({ message: 'Dados de login inválidos' });
                }

                if (error.request.status === HttpStatus.FORBIDDEN) {
                    /**
                     * Redirecionamento para a página principal após a notificação sumir.
                     */

                    notification.error({
                        message: error.response.data.message,
                        onClose: () => {
                            store.dispatch('setUsuarioLogado', null);
                        }
                    });
                }
            });
    }

    static async setHeader() {
        let jwt = sessionStorage.getItem('jwtToken');

        axios.defaults.headers.common.Authorization = `Bearer ${jwt}`;
        axios.defaults.headers.post['Content-Type'] =
            'application/x-www-form-urlencoded';
    }

    static async _setDefaultOptions(options) {
        options = options || {};
        options.fullUrl = options.url;
        options.lockScreen = Http._getOptionValue(options, 'lockScreen', true);
        options.lockMessage = options.lockMessage || i18n.t('mensagens.sistema.carregando');

        await Http.setHeader();

        return options;
    }

    static async get(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        var promisse;
        var responseType = options.responseType;

        if (options.data) {
            promisse = axiosInstance.get(options.fullUrl, {
                params: options.data,
                responseType
            });
        } else {
            promisse = axiosInstance.get(options.fullUrl, { responseType });
        }

        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }

    static async post(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        options.data = Array.isArray(options.data) ? [...options.data] : { ...options.data };

        var config = {
            ...options.config
        };

        if (options.responseType) {
            config = {
                ...options.config,
                responseType: options.responseType
            };
        }

        var promisse = axiosInstance.post(
            options.fullUrl,
            options.data,
            config
        );

        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }

    static async delete(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        var promisse = options.data
            ? axiosInstance.delete(options.fullUrl, { params: options.data })
            : axiosInstance.delete(options.fullUrl);

        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }

    static async put(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        var promisse = axiosInstance.put(options.fullUrl, options.data);

        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }

    static async patch(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        var promisse = axiosInstance.patch(options.fullUrl, options.data);

        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }

    static async putFormData(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        const axiosInstance = axios.create({
            baseURL: BASE_URL,
            responseType: 'multipart/form-data'
        });

        let formData = new FormData();
        formData.append(options.data.nome, options.data.content);

        var promisse = axiosInstance.put(options.fullUrl, formData);

        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }
}
